import { AccessType } from '../types/property.types';

export const orderStateOptions = [
  { value: 'AK', label: 'AK' },
  { value: 'AL', label: 'AL' },
  { value: 'AZ', label: 'AZ' },
  { value: 'AR', label: 'AR' },
  { value: 'CA', label: 'CA' },
  { value: 'CO', label: 'CO' },
  { value: 'CT', label: 'CT' },
  { value: 'DE', label: 'DE' },
  { value: 'DC', label: 'DC' },
  { value: 'FL', label: 'FL' },
  { value: 'GA', label: 'GA' },
  { value: 'HI', label: 'HI' },
  { value: 'ID', label: 'ID' },
  { value: 'IL', label: 'IL' },
  { value: 'IN', label: 'IN' },
  { value: 'IA', label: 'IA' },
  { value: 'KS', label: 'KS' },
  { value: 'KY', label: 'KY' },
  { value: 'LA', label: 'LA' },
  { value: 'ME', label: 'ME' },
  { value: 'MD', label: 'MD' },
  { value: 'MA', label: 'MA' },
  { value: 'MI', label: 'MI' },
  { value: 'MN', label: 'MN' },
  { value: 'MS', label: 'MS' },
  { value: 'MO', label: 'MO' },
  { value: 'MT', label: 'MT' },
  { value: 'NE', label: 'NE' },
  { value: 'NV', label: 'NV' },
  { value: 'NH', label: 'NH' },
  { value: 'NJ', label: 'NJ' },
  { value: 'NM', label: 'NM' },
  { value: 'NY', label: 'NY' },
  { value: 'NC', label: 'NC' },
  { value: 'ND', label: 'ND' },
  { value: 'OH', label: 'OH' },
  { value: 'OK', label: 'OK' },
  { value: 'OR', label: 'OR' },
  { value: 'PA', label: 'PA' },
  { value: 'PR', label: 'PR' },
  { value: 'RI', label: 'RI' },
  { value: 'SC', label: 'SC' },
  { value: 'SD', label: 'SD' },
  { value: 'TN', label: 'TN' },
  { value: 'TX', label: 'TX' },
  { value: 'UT', label: 'UT' },
  { value: 'VT', label: 'VT' },
  { value: 'VA', label: 'VA' },
  { value: 'VI', label: 'VI' },
  { value: 'WA', label: 'WA' },
  { value: 'WV', label: 'WV' },
  { value: 'WI', label: 'WI' },
  { value: 'WY', label: 'WY' }
];

export const propertyTypeOptions = [
  {
    value: 'Single Family',
    label: 'Single Family'
  },
  {
    value: 'Apartment',
    label: 'Apartment'
  },
  {
    value: 'Condo',
    label: 'Condo'
  },
  {
    value: 'Townhouse',
    label: 'Townhouse'
  },
  {
    value: 'Duplex',
    label: 'Duplex'
  },
  {
    value: 'Multiplex',
    label: 'Multiplex'
  },
  {
    value: 'Mobile Home',
    label: 'Mobile Home'
  },
  {
    value: 'Commercial',
    label: 'Commercial'
  },
  {
    value: 'Garage',
    label: 'Garage'
  },
  {
    value: 'Loft',
    label: 'Loft'
  }
];

// Access-type options are derived from the AccessType enum (the single source of
// truth, matching order-service's accepted values and the bulk-order template
// dropdown) so the lists can't drift out of sync again.
const accessTypeValues = Object.values(AccessType);

export const accessTypeOptions = accessTypeValues.map((value) => ({
  value,
  label: value
}));

export const leaseStatusOptions = [
  { value: 'Active', label: 'Active' },
  { value: 'Pending', label: 'Pending' },
  { value: 'Closed', label: 'Closed' }
];

// The order-summary form uses friendlier spaced labels for two values; the
// submitted value stays the canonical enum value.
const orderSummaryAccessLabels: Partial<Record<AccessType, string>> = {
  [AccessType.SMART_RENT]: 'Smart Rent',
  [AccessType.SHOW_MOJO]: 'Show Mojo'
};

export const accessTypeOptionsForOrderSummary = accessTypeValues.map((value) => ({
  value,
  label: orderSummaryAccessLabels[value] ?? value
}));

export const LastOrderDateOptions = [
  { value: 'less than a year', label: 'Less Than a Year' },
  { value: 'in between 1-2 years', label: 'In Between 1-2 Years' },
  { value: 'in between 2-3 years', label: 'In Between 2-3 Years' },
  { value: '3 years or greater', label: '3 Years or Greater' }
];

export const entityOptions = [
  { value: 'North', label: 'North' },
  { value: 'South', label: 'South' },
  { value: 'East', label: 'East' },
  { value: 'West', label: 'West' }
];

export const bathRoomOptions = [
  { value: '0.5', label: '0.5' },
  { value: '1', label: '1' },
  { value: '1.5', label: '1.5' },
  { value: '2', label: '2' },
  { value: '2.5', label: '2.5' },
  { value: '3', label: '3' },
  { value: '3.5', label: '3.5' },
  { value: '4', label: '4' },
  { value: '4.5', label: '4.5' },
  { value: '5', label: '5' }
];

export const booleanOptions = [
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' }
];

export const bedRoomOptions = [
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' },
  { value: '6', label: '6' },
  { value: '7', label: '7' },
  { value: '8', label: '8' },
  { value: '9', label: '9' },
  { value: '10', label: '10' }
];
